import { createApi } from '@reduxjs/toolkit/query/react';
import { createQuietBaseQuery } from './Shared/quietBaseQuery';

export type InviteUnusableState = 'used' | 'revoked' | 'expired';

export type InviteValidation =
  | {
      state: 'valid';
      firstName: string;
      schoolName: string;
      /** The server may not report a minimum. */
      passwordRules: { minLength: number | null };
    }
  | { state: InviteUnusableState };

type ValidateInviteArgs = { token: string };

export type ClaimInviteArgs = {
  token: string;
  password: string;
  confirmPassword: string;
  sessionId: string;
};

export type ClaimInviteResponse = {
  success: boolean;
  sessionId: string;
  nextStep: 'CONFIRM_OTP';
  destination: { channel: 'sms' | 'whatsapp' | 'email'; maskedValue: string };
};

const quietBaseQuery = createQuietBaseQuery('invite-claim');

export const InviteApi = createApi({
  reducerPath: 'InviteApi',
  baseQuery: quietBaseQuery,
  endpoints: builder => ({
    // POST so the token travels in the body — never in a path or a Referer.
    validateInvite: builder.query<InviteValidation, ValidateInviteArgs>({
      query: ({ token }) => ({ url: '/2fa/invite/validate', method: 'POST', body: { token } }),
      keepUnusedDataFor: 0,
    }),
    claimInvite: builder.mutation<ClaimInviteResponse, ClaimInviteArgs>({
      query: body => ({ url: '/2fa/invite/claim', method: 'POST', body }),
    }),
  }),
});

export const { useValidateInviteQuery, useClaimInviteMutation } = InviteApi;
